import { DatePipe, NgClass, NgStyle, NgIf, NgFor } from "@angular/common";
import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Input, signal, ViewChild, WritableSignal } from "@angular/core";
import { RouterLink } from "@angular/router";
import KeenSlider from "keen-slider";
import { KebabCasePipe } from "../../../pipes/kebab-case.pipe";
import { SafeResourceUrlPipe } from "../../../pipes/safeResourceUrl/safe-resource-url.pipe";
import { AnimacionVideoComponent } from "../../animacion-video/animacion-video.component";
import { SkeletonImageComponent } from "../../skeleton-image/skeleton-image/skeleton-image.component";

@Component({
  selector: "app-fila-una-columna",
  templateUrl: "./fila-una-columna.component.html",
  styleUrls: ["./fila-una-columna.component.css"],
  imports: [NgClass, NgStyle, RouterLink, AnimacionVideoComponent, DatePipe, KebabCasePipe, SafeResourceUrlPipe, SkeletonImageComponent, NgIf, NgFor],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilaUnaColumnaComponent implements AfterViewInit {
  @Input() noticias = [];
  @Input() idStart;
  @Input() lcp: boolean;
  @Input() isPriority: boolean = false;
  @Input() autorEmpresa;
  @Input() showFecha = true;

  relacionadasSlider: WritableSignal<object> = signal({});

  slider = signal(null);
  sliderMobile = signal(null);
  @ViewChild("sliderRef") sliderRef: ElementRef<HTMLElement>;
  @ViewChild("sliderMobileRef") sliderMobileRef: ElementRef<HTMLElement>;

  ngAfterViewInit(): void {
    if (this.noticias[0] && this.noticias[0].noticias_relacionadas) {
      this.slider.set(this.initSlider(this.sliderRef, 3));
      this.sliderMobile.set(this.initSlider(this.sliderMobileRef, 2));
    }
  }

  initSlider(container, perView) {
    return new KeenSlider(
      container.nativeElement,
      {
        loop: true,
        slides: {
          perView,
        },
        drag: false,
      },
      [
        (slider) => {
          let timeout;
          let mouseOver = false;
          function clearNextTimeout() {
            clearTimeout(timeout);
          }
          function nextTimeout() {
            if (this.platformService.isBrowser()) {
              clearTimeout(timeout);
              if (mouseOver) return;
              timeout = setTimeout(() => {
                slider.next();
              }, 2000);
            }
          }
          slider.on("created", () => {
            slider.container.addEventListener("mouseover", () => {
              mouseOver = true;
              clearNextTimeout();
            });
            slider.container.addEventListener("mouseout", () => {
              mouseOver = false;
              nextTimeout();
            });
            nextTimeout();
          });
          slider.on("dragStarted", clearNextTimeout);
          slider.on("animationEnded", nextTimeout);
          slider.on("updated", nextTimeout);
        },
      ],
    );
  }

  formatDate(obj) {
    return obj.toString().replace(/\s/g, "T");
  }
}
